  (function(){
    var root = document.querySelector('.hsp'); if(!root) return;
    var T = window.HSP_T || {}, CT = T.colours || {};
    var FRAMES = ['ion','ceres','helios'], LENSES = ['sleep','relax','focus'];
    var colorsWrap = root.querySelector('.hsp__colors');
    var note       = root.querySelector('.hsp__note');
    var stockEl    = root.querySelector('[data-hsp-stock]');
    var stockTx    = root.querySelector('[data-hsp-stock-text]');
    var POP = window.HSP_POPULAR || {};
    var FIRE = '<span class="hsp__fire" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor">' +
      '<path d="M12.6 1.6a.6.6 0 0 0-1 .3c-.2 2.4-1.3 3.8-2.6 5.2C7.5 8.7 6 10.4 6 13.4 6 17.6 8.9 21 12.6 21c3.7 0 6.4-3.1 6.4-7 0-2.3-1-4.1-2.3-5.7a.6.6 0 0 0-1 .2c-.2.7-.5 1.2-.9 1.6.2-3.2-1-6-2.2-8.5z"/>' +
      '<path d="M12.4 12.1a.5.5 0 0 0-.9.1c-.3 1.1-.8 1.7-1.3 2.3-.5.6-1 1.3-1 2.4 0 1.7 1.2 3 2.8 3s2.9-1.3 2.9-3.1c0-1.6-1.3-3.2-2.5-4.7z" fill="#FFF7EC"/>' +
      '</svg></span>';
    /* Both pairs are editable now, so state holds one config per slot and
       `active` says which one the picker is aimed at. */
    var slots = { 1: { lens:null, frame:null, color:null }, 2: { lens:null, frame:null, color:null } };
    var active = 2;
    var state = { mode: '2' };

    function form(){ return document.querySelector('form[is="product-form"], product-form form, form[action*="/cart/add"]'); }
    function liveVid(){ var f=form(); var i=f && f.querySelector('[name="id"]'); return i ? i.value : root.dataset.currentVariant; }
    function atc(){ var f=form(); return f && f.querySelector('buy-buttons button[type="submit"], button[type="submit"]'); }

    /* Same figures as the lens buttons and the blue-light blocks on the page.
       Change one, change all of them. */
    var LENS_PCT = { sleep: 99, relax: 97, focus: 84 };
    /* The cutoff moves with the tint — a deeper lens does not just block more
       of the same band, it blocks further up the spectrum. Yellow takes the
       top of blue, amber takes all of it, red carries on into green. So the
       range belongs to the lens, not to the section.
       Note 450–500 nm elsewhere on the site is a different figure: that is the
       melanopsin band that drives melatonin, not what the lens filters. */
    var LENS_BAND = { sleep: '400–560 nm', relax: '400–500 nm', focus: '400–450 nm' };

    function keyOf(n){ var c=slots[n]; return (c.frame||'') + '_' + (c.color||'') + '_' + (c.lens||''); }
    function prodOf(n){ return HEVO2P.products[keyOf(n)] || null; }
    function cap(s){ return s.charAt(0).toUpperCase() + s.slice(1); }

    /* Pair 1 starts as whatever product the page is showing — found by
       matching the live variant id back to the map rather than parsing the
       handle, so a renamed handle can't silently break it. */
    (function seedSlot1(){
      var vid = Number(liveVid());
      var found = null;
      Object.keys(HEVO2P.products).forEach(function(k){ if(HEVO2P.products[k].id === vid) found = k; });
      if(found){ var p=found.split('_'); slots[1] = { frame:p[0], color:p[1], lens:p[2] }; }
      else { slots[1] = { frame: root.dataset.frame || 'ceres', color:'black', lens: root.dataset.rec === 'sleep' ? 'focus' : 'sleep' }; }
    })();
    slots[2] = { frame: root.dataset.frame || 'ceres', lens: null, color: null };
    slots[2].lens = recLens() || 'focus';

    var built = '';
    var META = window.HSP_META || {};
    var META_OK = Object.keys(META).length > 5;
    function sellable(p){ return !META_OK || !!META[p.id]; }
    FRAMES.forEach(function(f){ LENSES.forEach(function(l){ HEVO2P.order.forEach(function(c){
      var p = HEVO2P.products[f + '_' + c + '_' + l]; if(!p || !sellable(p)) return;
      built += '<button type="button" class="hsp__color" data-frame="'+f+'" data-lens="'+l+'" data-color="'+c+'" data-name="'+(CT[p.color]||p.color)+'" hidden>' +
        '<span class="hsp__swatch"><img src="'+p.img+'" alt="'+p.color+'" loading="lazy" decoding="async">'+(POP[p.id]?FIRE:'')+'</span>' +
        '<span class="hsp__color-name">'+(CT[p.color]||p.color)+'</span></button>';
    }); }); });
    colorsWrap.innerHTML = built;
    var emptyEl = document.createElement('p'); emptyEl.className='hsp__empty'; emptyEl.textContent=T.empty; emptyEl.hidden=true;
    colorsWrap.appendChild(emptyEl);
    var allCards = [].slice.call(colorsWrap.querySelectorAll('.hsp__color'));

    /* ── Painting ── */
    function nameOf(n){
      var c=slots[n]; if(!c.frame || !c.color || !c.lens) return null;
      var card = colorsWrap.querySelector('.hsp__color[data-frame="'+c.frame+'"][data-lens="'+c.lens+'"][data-color="'+c.color+'"]');
      return cap(c.frame) + ' ' + (card ? card.dataset.name : cap(c.color)) + ' · ' + cap(c.lens);
    }
    /* The "combine with" chip under the two slots (moved here from under the
       page headline). Same pairing as the REK. badge (recLens). It suggests
       the other half of the pair while it is missing — one pair chosen, or the
       same lens twice — and confirms the pair once it is in the box. */
    var COMBO = window.HSP_COMBO || {};
    var CHECK = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function paintCombo(){
      var el = root.querySelector('[data-hsp-combo]'); if(!el || !COMBO.with) return;
      var l1 = slots[1].lens, rec = recLens();
      if(!rec){ el.hidden = true; return; }
      var done = state.mode === '2' && slots[2].lens === rec;
      el.classList.toggle('is-done', done);
      el.disabled = done;
      if(done){
        var pairTxt = (l1 === 'relax' || rec === 'relax') ? COMBO.rs : COMBO.fs;
        el.innerHTML = CHECK + '<span>' + pairTxt + '</span>';
      } else {
        el.innerHTML = '<i class="hsp__dot is-' + rec + '" aria-hidden="true"></i><span>' +
          COMBO.with.replace('{lens}', '<b>' + cap(rec) + ' Lens</b>').replace('{why}', COMBO[rec] || '') + '</span>';
      }
      el.dataset.rec = rec;
      el.hidden = false;
    }

    function paintSlots(){
      paintCombo();
      [1,2].forEach(function(n){
        var btn = root.querySelector('.hsp__slot[data-slot="'+n+'"]');
        btn.classList.toggle('is-active', n===active);
        btn.setAttribute('aria-selected', n===active ? 'true' : 'false');
        var p = prodOf(n), wrap = root.querySelector('[data-slot-img="'+n+'"]'), nm = root.querySelector('[data-slot-name="'+n+'"]');
        var blk = root.querySelector('[data-slot-block="'+n+'"]');
        var sh  = root.querySelector('[data-slot-short="'+n+'"]');
        if(p){
          wrap.classList.remove('is-empty'); wrap.querySelector('img').src = p.img; nm.textContent = nameOf(n);
          var pct = LENS_PCT[slots[n].lens];
          sh.textContent = cap(slots[n].lens);
          if(pct){ blk.textContent = pct + '% ' + (T.blockword || 'block'); blk.className = 'hsp__slot-pct is-' + slots[n].lens; blk.hidden = false; }
          else { blk.hidden = true; }
        }
        else { wrap.classList.add('is-empty'); nm.textContent = T.choose; sh.textContent = ''; blk.hidden = true; }
      });
    }

    /* Follows whichever slot is being picked, so the number always describes
       the lens the shopper just tapped. */
    /* How much light each lens lets through at w nm, fitted to the lens
       meter (same curves as sections/hevo-wavelength.liquid).
       A flat rainbow made Focus look as if it did nothing: 400–450 nm is a
       sliver of the spectrum. But screen light is not flat — a white LED has
       a tall, narrow blue peak at ~450 nm and a broad, lower warm hump. Drawn
       as a screen's light, the peak is the biggest thing on the chart, and
       it is exactly what Focus removes. */
    function sig(x){ return 1 / (1 + Math.exp(-x)); }
    var SPEC_T = {
      focus: function(w){ var a = sig((w - 458) / 3); return 0.02 + 0.98 * (0.7 * a + 0.3 * a * sig((w - 530) / 25)); },
      relax: function(w){ return 0.01 + 0.97 * sig((w - 558) / 18); },
      sleep: function(w){ return 0.002 + 0.798 * sig((w - 596) / 12); }
    };
    var SPEC_N = 121, SPEC_W = [], SPEC_S = [], specCur = null, specRaf = 0;
    (function(){
      function g(w, m, sd, k){ var z = (w - m) / sd; return k * Math.exp(-0.5 * z * z); }
      var mx = 0, i, w;
      for(i = 0; i < SPEC_N; i++){
        w = 400 + 300 * i / (SPEC_N - 1); SPEC_W.push(w);
        SPEC_S.push(g(w, 450, 11, 1) + g(w, 548, 40, 0.5) + g(w, 612, 26, 0.36));
        mx = Math.max(mx, SPEC_S[i]);
      }
      for(i = 0; i < SPEC_N; i++) SPEC_S[i] /= mx;
    })();
    /* Transmission scaled to the lens's own maximum, so what it passes is
       drawn at full height and only what it blocks goes. */
    function specTarget(l){
      var f = SPEC_T[l], out = [], mx = 0, i;
      if(!f){ for(i = 0; i < SPEC_N; i++) out.push(1); return out; }
      for(i = 0; i < SPEC_N; i++) mx = Math.max(mx, f(SPEC_W[i]));
      for(i = 0; i < SPEC_N; i++) out.push(f(SPEC_W[i]) / mx);
      return out;
    }
    function specPath(T){
      var top = 6, base = 59.5, h = base - top, d = 'M0,' + base, i;
      for(i = 0; i < SPEC_N; i++){
        d += 'L' + (300 * i / (SPEC_N - 1)).toFixed(1) + ',' + (base - h * SPEC_S[i] * (T ? T[i] : 1)).toFixed(2);
      }
      return d + 'L300,' + base + 'Z';
    }
    function specDraw(el, l){
      var ghost = el.querySelector('.hsp__spec-ghost'), pass = el.querySelector('.hsp__spec-pass');
      if(!ghost || !pass) return;
      if(!ghost.getAttribute('d')) ghost.setAttribute('d', specPath(null));
      var to = specTarget(l), from = specCur || to;
      cancelAnimationFrame(specRaf);
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(!specCur || reduce){ specCur = to; pass.setAttribute('d', specPath(to)); return; }
      var t0 = performance.now(), dur = 450;
      (function step(now){
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3), cur = [];
        for(var i = 0; i < SPEC_N; i++) cur.push(from[i] + (to[i] - from[i]) * e);
        specCur = cur; pass.setAttribute('d', specPath(cur));
        if(k < 1) specRaf = requestAnimationFrame(step);
      })(t0);
    }

    function paintLensNote(){
      var el = root.querySelector('[data-hsp-lensnote]'); if(!el) return;
      var l = slots[active].lens, pct = LENS_PCT[l];
      if(!pct){ el.hidden = true; return; }
      var band = LENS_BAND[l] || '', hi = +((band.match(/(\d+)\D+(\d+)/) || [])[2] || 400);
      el.className = 'hsp__spec is-' + l;
      /* The chart runs 400–700 nm; the "passes through" label starts at the
         lens's upper edge. */
      el.style.setProperty('--cut', Math.max(0, Math.min(100, (hi - 400) / 3)).toFixed(1) + '%');
      el.querySelector('[data-spec-text]').innerHTML = (T.blocknote || '').replace('{pct}', '<b>' + pct + '%</b>').replace('%</b>%', '%</b>');
      el.querySelector('[data-spec-band]').textContent = band;
      el.hidden = false;
      specDraw(el, l);
      paintCombo();
    }

    function paintStock(){
      var p = prodOf(active);
      var m = p ? (window.HSP_META||{})[p.id] : null;
      if(!m || !m.t){ stockEl.hidden = true; return; }
      var q = m.q, cls, txt;
      /* TEMPORARY (Black Friday 2026): the no-restock message now sits in the
         limited-price line at the top of the page, so the box only speaks up
         when stock is low. Delete this block to go back to the green line. */
      if(T.bf && q > 0){
        if(q < 20){ stockEl.className = 'hsp__stock is-low'; stockTx.textContent = T.onlyA + q + T.onlyB; stockEl.hidden = false; }
        else { stockEl.hidden = true; }
        return;
      }
      if(q <= 0){ cls='is-sold'; txt=T.sold; }
      else if(q < 20){ cls='is-low'; txt=T.onlyA + q + T.onlyB; }
      else { cls='is-ok'; txt=T.instock; }
      stockEl.className = 'hsp__stock ' + cls; stockTx.textContent = txt; stockEl.hidden = false;
    }

    /* ── Pair 1 drives the page itself: gallery, title, URL. No reload. ── */
    var galCache = {};
    function fetchProduct(handle){
      if(galCache[handle]) return Promise.resolve(galCache[handle]);
      return fetch('/products/'+handle+'.js').then(function(r){ if(!r.ok) throw new Error('404'); return r.json(); })
        .then(function(d){ galCache[handle]=d; return d; });
    }
    /* The server already rendered this product's gallery with proper srcset
       and sizes. Rewriting it at boot replaced every image with a bare
       full-size URL — 3.4MB of waste on a phone before any interaction. Only
       rewrite when pair 1 actually changes product. */
    var appliedHandle = (location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1] || null;

    function applyPair1(){
      var p = prodOf(1); if(!p) return;
      var meta = (window.HSP_META||{})[p.id]; var handle = meta && meta.h;
      var single = root.querySelector('.hsp__head-sub--name');
      if(single) single.textContent = nameOf(1);
      if(!handle || handle === appliedHandle) return;
      appliedHandle = handle;
      fetchProduct(handle).then(function(d){
        var t = document.querySelector('.product-info__title'); if(t) t.textContent = d.title;
        document.title = d.title;
        /* Keep the locale prefix (/sv/, /en-eu/): a bare /products/ path sent a
           reload or a shared link to the English root. */
        try { history.replaceState({}, '', ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle); } catch(e){}
        /* Rewrite the gallery in place. srcset is cleared or the browser keeps
           serving candidates from the previous product. */
        var medias = document.querySelectorAll('.product-gallery__media');
        var thumbs = document.querySelectorAll('.product-gallery__thumbnail-list-wrapper img');
        var imgs = d.images || [];
        /* Sized like the server would: viewport-scale for slides, thumb-scale
           for thumbnails — not the bare original, which is up to 2048px. */
        var slideW = Math.min(1400, Math.round(Math.max(innerWidth, 750) * (devicePixelRatio || 1)));
        for (var i = 0; i < medias.length; i++) {
          var src = imgs[i];
          if (src) {
            var abs = (src.indexOf('//')===0 ? 'https:'+src : src);
            var el = medias[i].querySelector('img');
            if (el) { el.srcset = ''; el.src = sized(abs, slideW); el.alt = d.title; }
            medias[i].hidden = false;
            if (thumbs[i]) { thumbs[i].srcset = ''; thumbs[i].src = sized(abs, 128); if(thumbs[i].closest('button')) thumbs[i].closest('button').hidden = false; }
          } else {
            medias[i].hidden = true;
            if (thumbs[i] && thumbs[i].closest('button')) thumbs[i].closest('button').hidden = true;
          }
        }
      }).catch(function(){});
    }

    function pickColor(b){
      slots[active].color = b.dataset.color;
      allCards.forEach(function(x){ x.classList.toggle('is-selected', x===b); });
      paintSlots(); paintStock(); paintLensNote(); syncButton();
      if(active===1) applyPair1();
    }
    allCards.forEach(function(b){ b.addEventListener('click', function(){ pickColor(b); }); });

    function setSeg(sel, attr, val){ root.querySelectorAll(sel).forEach(function(x){ x.classList.toggle('is-selected', x.dataset[attr]===val); }); }

    /* Frames that exist for the lens in hand (Relax is Helios-only). The others
       go pale and can't be clicked; if the slot sits on one of them, it moves
       to the first frame that has the lens instead of showing an empty grid. */
    function paintFrames(){
      var c = slots[active];
      var ok = {};
      allCards.forEach(function(b){ if(b.dataset.lens===c.lens) ok[b.dataset.frame] = true; });
      var any = Object.keys(ok).length > 0;
      root.querySelectorAll('.hsp__frame').forEach(function(b){
        var off = any && !ok[b.dataset.frame];
        b.disabled = off;
        b.classList.toggle('is-unavailable', off);
        b.setAttribute('aria-disabled', off ? 'true' : 'false');
      });
      if(any && !ok[c.frame]){
        var first = FRAMES.filter(function(f){ return ok[f]; })[0];
        if(first){ c.frame = first; setSeg('.hsp__frame','frame',c.frame); }
      }
    }

    function showColors(){
      var c = slots[active], visible = [];
      allCards.forEach(function(b){
        var show = b.dataset.frame===c.frame && b.dataset.lens===c.lens;
        b.hidden = !show; b.classList.remove('is-selected');
        if(show) visible.push(b);
      });
      emptyEl.hidden = visible.length > 0;
      /* Keep the colour if it survives the new frame/lens combination. */
      var keep = c.color ? visible.filter(function(b){ return b.dataset.color===c.color; })[0] : null;
      if(keep) pickColor(keep);
      else if(visible.length) pickColor(visible[0]);
      else { c.color = null; paintSlots(); paintStock(); paintLensNote(); syncButton(); }
    }

    function repaintPicker(){
      var c = slots[active];
      setSeg('.hsp__lens','lens',c.lens);
      setSeg('.hsp__frame','frame',c.frame);
      paintFrames();
      applyRec();
      paintLensNote();
      showColors();
    }

    root.querySelectorAll('.hsp__lens').forEach(function(b){ b.addEventListener('click', function(){
      slots[active].lens=b.dataset.lens; setSeg('.hsp__lens','lens',slots[active].lens);
      paintFrames();
      if(active===1) applyRec();
      showColors();
    }); });
    root.querySelectorAll('.hsp__frame').forEach(function(b){ b.addEventListener('click', function(){ slots[active].frame=b.dataset.frame; setSeg('.hsp__frame','frame',slots[active].frame); showColors(); }); });

    root.querySelectorAll('.hsp__slot').forEach(function(btn){
      btn.addEventListener('click', function(){ active = Number(btn.dataset.slot); paintSlots(); repaintPicker(); });
    });

    /* Tapping the chip: two pairs, pair 2 set to the recommended lens. */
    (function(){
      var el = root.querySelector('[data-hsp-combo]'); if(!el) return;
      el.addEventListener('click', function(){
        if(el.classList.contains('is-done')) return;
        var rec = el.dataset.rec; if(!rec) return;
        var two = root.querySelector('.hsp__radio[value="2"]');
        if(two && !two.checked){ two.checked = true; two.dispatchEvent(new Event('change', { bubbles: true })); }
        active = 2; paintSlots(); repaintPicker();
        var lb = root.querySelector('.hsp__lens[data-lens="' + rec + '"]');
        if(lb) lb.click();
        paintCombo();
      });
    })();

    /* ── Mode switch ── */
    root.querySelectorAll('.hsp__radio').forEach(function(r){
      r.addEventListener('change', function(){
        state.mode = r.value;
        root.querySelectorAll('.hsp__opt').forEach(function(o){ o.classList.toggle('is-active', o.dataset.mode===state.mode); });
        root.classList.toggle('mode-1', state.mode==='1');
        /* The picker aims at the pair the mode is about. */
        active = (state.mode==='1') ? 1 : 2;
        paintSlots(); repaintPicker();
        syncButton();
      });
    });

    /* ── The theme's Add-to-cart is the only CTA. In 2-pair mode rewrite its
       price label, and hide the dynamic checkout button, which can only ever
       carry the single line item the form holds. ── */
    /* The store's money format applied to a total worked out at runtime. The
       button used to echo strings Liquid had already rendered; with add-ons in
       the sum there is no such string to echo. Separators differ per shop, so
       the pattern is read from shop.money_format rather than assumed. */
    /* NOK/DKK use Shopify's default "{{amount_with_comma_separator}} kr", which
       prints ",00" on whole prices. Drop only a zero ",00" before "kr" — real
       öre (",50") stay, so the page never shows a different sum than checkout. */
    function hspMoney(cents){
      var s = hspMoneyRaw(cents).replace(/,00(?=\s*kr\b)/, '');
      /* Swedish writes 1 017 kr, not 1,017 kr (non-breaking space). */
      if(window.HSP_SV) s = s.replace(/(\d),(?=\d{3}(?!\d))/g, '$1\u00a0');
      return s;
    }
    function hspMoneyRaw(cents){
      var fmt = window.HSP_MONEY || '';
      function part(thousands, decimal, places){
        var n = (cents/100).toFixed(places).split('.');
        n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return places ? n.join(decimal) : n[0];
      }
      if(!fmt) return part(',', '.', 2);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, name){
        switch(name){
          case 'amount_no_decimals':                      return part(',', '.', 0);
          case 'amount_with_comma_separator':             return part('.', ',', 2);
          case 'amount_no_decimals_with_comma_separator': return part('.', ',', 0);
          case 'amount_with_space_separator':             return part(' ', ',', 2);
          case 'amount_no_decimals_with_space_separator': return part(' ', ',', 0);
          case 'amount_with_apostrophe_separator':        return part("'", '.', 2);
          default:                                        return part(',', '.', 2);
        }
      });
    }

    /* Shared so the add-ons block can print a running saving in the store's
       own format instead of carrying a second copy of this. */
    window.hspMoney = hspMoney;

    function addonSum(fn){
      var A = window.HevoAddons;
      return (A && typeof A[fn] === 'function') ? (A[fn]() || 0) : 0;
    }

    /* ── What the pairs in the slots actually cost ──
       The two-pair total used to be the PAGE's price x 2 x 0.8, which is only
       right when both pairs cost the same. Helios is 595 and Ceres 675, so a
       mixed pair was quoted as two of whichever product the page showed.
       Measured against the cart on 2026-09-25: the automatic SECOND PAIR
       discount takes 30% off BOTH lines (20% until 2026-10-10: 675 + 595 was
       charged 540 + 476), so
       the rule was right and only its inputs were wrong. Per-line rounding
       mirrors how the cart applies it.
       PAIR_KEEP must move with the `times: 70` in bundle_price and in
       hsp_variant_data above. */
    var PAIR_KEEP = 70;

    function priceOf(n){
      var p = prodOf(n), m = p && META[p.id];
      if(!m || typeof m.p !== 'number') return null;
      return { now: m.p, full: Math.max(m.c || 0, m.p) };
    }

    function pairMoney(){
      var d = window.HSP_PRICES[liveVid()];
      var a = priceOf(1), b = priceOf(2);
      if(!a && !d) return null;
      /* Pair 1 is read from its slot, not the page: it can be swapped inside
         the box, and the gallery and title follow it but the form's variant
         does not — so the page price goes stale the moment it is changed. */
      var one  = a ? a.now  : d.sn;
      var oneF = a ? a.full : Math.max(d.scn || 0, d.sn);
      /* Pair 2 has no colour until one is picked. Until then it is costed as a
         copy of pair 1 — the old estimate, and the best guess there is. */
      var two  = b ? b.now  : one;
      var twoF = b ? b.full : oneF;
      return {
        single: one, singleFull: oneF,
        bundle: Math.round(one * PAIR_KEEP / 100) + Math.round(two * PAIR_KEEP / 100),
        bundleFull: oneF + twoF
      };
    }

    /* ── The button label ──
       Written only when it would actually change, and marked as ours. The
       marker is how resync tells "the theme re-rendered the button" from "this
       is our own label". It used to test for the words "Add 2 pairs" instead,
       which every other label we write fails — so once a second it decided the
       button had been reset, rewrote it, and saved our own "To checkout" label
       as the theme's original. Unticking later restored that: a single pair
       with nothing ticked was shown at the price of a pair plus an add-on. */
    function ours(b){ return b.dataset.hspWrote !== undefined && b.innerHTML === b.dataset.hspWrote; }
    function writeLabel(b, html){
      if(b.dataset.hspWant === html && ours(b)) return;
      b.innerHTML = html;
      b.dataset.hspWant = html;
      b.dataset.hspWrote = b.innerHTML;
    }

    function syncButton(){
      var b = atc(); if(!b) return;
      /* The theme's button snippet puts its content directly in <button>, with
         no label wrapper. The original is captured from the theme's markup
         only — never from one of our labels, or it would later be "restored"
         as if the theme had written it. */
      if(!b.dataset.hspOrig && !ours(b)) b.dataset.hspOrig = b.innerHTML;
      paintPrices();

      var m = pairMoney();
      var d = window.HSP_PRICES[liveVid()];
      var extra = addonSum('total'), extraFull = addonSum('totalCompare');
      var orig = b.dataset.hspOrig || '';
      var cut = orig.indexOf('  —  ');
      var singleWord = cut > 0 ? orig.slice(0, cut) : null;
      /* The theme's label prices the page's product, so it is only true while
         pair 1 costs what that product costs. */
      var pairOneIsPage = !m || !d || m.single === d.sn;

      if(!extra && state.mode!=='2' && (!singleWord || b.disabled || !m)){
        writeLabel(b, orig);
      } else if(m){
        var two  = state.mode==='2';
        var now  = (two ? m.bundle : m.single) + extra;
        var was  = (two ? m.bundleFull : m.singleFull) + extraFull;
        /* "Add 2 pairs" stops being true the moment an accessory is ticked,
           so anything ticked and the label says where the button leads. */
        var word = extra > 0 ? (T.checkout || T.atc) : (two ? T.atc : (T.checkout || singleWord));
        writeLabel(b, word + ' · ' + hspMoney(now) +
          (was > now ? ' <s style="opacity:.55;font-weight:400;margin-left:6px;text-decoration:line-through;">' + hspMoney(was) + '</s>' : ''));
      } else {
        writeLabel(b, orig);
      }

      /* Hidden for ticked add-ons as well as for two pairs. The dynamic
         checkout button carries only the one line item the form holds, so it
         would take the shopper straight past everything they just picked. */
      var f = form(); var pay = f && f.querySelector('.shopify-payment-button');
      if(pay) pay.style.display = (state.mode==='2' || extra > 0) ? 'none' : '';
    }

    /* The add-ons block announces its own changes; the button belongs to this
       file, so the repaint happens here. */
    document.addEventListener('hevo:addons-change', syncButton);

    document.addEventListener('click', function(e){
      if(!e.target.closest) return;
      var clicked = e.target.closest('buy-buttons button[type="submit"]');
      if(!clicked) return;
      /* The main section also renders accessory/offer blocks, each with its
         own buy-buttons. Only the product form's own button is ours to hijack
         — otherwise adding a case would silently add the glasses bundle. */
      var b = atc();
      if(!b || clicked !== b || b.disabled) return;
      var p1 = prodOf(1), p2 = prodOf(2);
      var needed = (state.mode==='2') ? (p1 && p2) : p1;
      if(!needed){ e.preventDefault(); e.stopPropagation(); note.hidden=false; note.textContent=T.empty; return; }
      e.preventDefault(); e.stopPropagation();
      note.hidden = true;
      b.setAttribute('aria-busy','true');
      /* Add exactly the slots the box displays. Pair 1 is no longer read from
         the page form — it can have been changed here without a reload. */
      var items = [{ id:p1.id, quantity:1 }];
      if(state.mode==='2') items.push({ id:p2.id, quantity:1, properties:{ '_offer':'2nd pair (-30%)', '_u':'1' } });
      /* Accessories ticked under the button ride along in the SAME batch. A
         second request would add them to a cart the discount had already been
         evaluated on, and the rate is keyed on glasses being present. */
      if (window.HevoAddons && typeof HevoAddons.selected === 'function') {
        items = items.concat(HevoAddons.selected());
      }
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json(); })
        .then(function(){
          b.removeAttribute('aria-busy');
          /* Untick, or pressing the button again silently doubles them. */
          if (window.HevoAddons && typeof HevoAddons.clear === 'function') HevoAddons.clear();
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          if(window.HevoCart && typeof HevoCart.open==='function'){ HevoCart.open(); }
          else { var _l=document.querySelector('a[href="/cart"],a[href$="/cart"],[data-action="open-cart"]'); if(_l){ _l.click(); } else { window.location.href='/cart'; } }
        })
        .catch(function(){ b.removeAttribute('aria-busy'); note.hidden=false; note.textContent=T.err; });
    }, true);

    /* ── "See all images" for whichever pair 2 is currently selected ──
       Images are fetched from /products/<handle>.js the first time a product
       is opened and cached after that, so the picker stays light and the
       gallery always matches what's on the product. */
    var lb = root.querySelector('.hsp__lb');
    var lbBody = lb.querySelector('[data-hsp-lb-body]');
    var lbTitle = lb.querySelector('[data-hsp-lb-title]');
    var seeall = root.querySelector('[data-hsp-seeall]');
    document.body.appendChild(lb); /* portal out of any clipping ancestor */
    var lbCache = {};

    function lbClose(){ lb.hidden = true; document.documentElement.style.overflow=''; }
    function lbOpen(){ lb.hidden = false; document.documentElement.style.overflow='hidden'; }

    function sized(u, w){
      var url = (u.indexOf('//')===0) ? ('https:'+u) : u;
      return url + (url.indexOf('?')>-1 ? '&' : '?') + 'width=' + w;
    }

    function renderGallery(imgs, name){
      lbTitle.textContent = name;
      if(!imgs || !imgs.length){ lbBody.innerHTML = '<p class="hsp__lb-note">'+T.empty+'</p>'; return; }
      lbBody.innerHTML = imgs.map(function(u, i){
        return '<img class="hsp__lb-img" src="'+sized(u,900)+'" alt="'+name+'" loading="'+(i<4?'eager':'lazy')+'" decoding="async">';
      }).join('');
      lbBody.scrollTop = 0;
    }

    function showGallery(){
      var p = prodOf(active); if(!p) return;
      var meta = (window.HSP_META||{})[p.id];
      var handle = meta && meta.h;
      var name = nameOf(active) || '';
      lbOpen();
      if(lbCache[p.id]){ renderGallery(lbCache[p.id], name); return; }
      lbTitle.textContent = name;
      lbBody.innerHTML = '<p class="hsp__lb-note">'+T.loading+'</p>';
      if(!handle){ renderGallery([p.img], name); return; }
      fetch('/products/'+handle+'.js')
        .then(function(r){ if(!r.ok) throw new Error('404'); return r.json(); })
        .then(function(d){ var imgs = (d.images && d.images.length) ? d.images : [p.img]; lbCache[p.id]=imgs; renderGallery(imgs, name); })
        /* Falls back to the swatch image rather than an empty sheet. */
        .catch(function(){ lbCache[p.id]=[p.img]; renderGallery([p.img], name); });
    }

    seeall.addEventListener('click', showGallery);
    lb.querySelector('.hsp__lb-close').addEventListener('click', lbClose);
    lb.addEventListener('click', function(e){ if(e.target===lb) lbClose(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !lb.hidden) lbClose(); });

    /* ── Follow the live variant: prices, recommendation, button label ── */
    var LENSMAP = window.HSP_LENS || {};
    var els = {
      b:  root.querySelector('[data-hsp-bundle]'),
      bc: root.querySelector('[data-hsp-bundle-compare]'),
      sv: root.querySelector('[data-hsp-saved]'),
      s:  root.querySelector('[data-hsp-single]'),
      sc: root.querySelector('[data-hsp-single-compare]'),
      bd: root.querySelector('[data-hsp-bundle-day]'),
      sd: root.querySelector('[data-hsp-single-day]')
    };
    /* Price per day over a year (price / 365) with two decimals — the shop's
       money format drops them, so the amount is built here and dropped into
       that format: "1,90 kr/dag under ett år", "€0.23/day for a year". */
    function perDay(cents){
      var fmt = window.HSP_MONEY || '';
      var name = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [,''])[1];
      var sv = (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0;
      var comma = sv || name.indexOf('comma') !== -1;
      var v = (cents / 36500).toFixed(2);
      if(comma) v = v.replace('.', ',');
      var money = fmt ? fmt.replace(/\{\{\s*\w+\s*\}\}/, v) : v;
      return (T.perday || '[amount]').replace('[amount]', money);
    }
    /* The plan rows are priced from the slots as well, and repainted on every
       slot change (syncButton calls this) — not only when the page's variant
       changes, which is the one thing that never happens while a shopper is
       picking pair 2. */
    function paintPrices(){
      if(!els) return;
      var m = pairMoney(); if(!m) return;
      if(els.b)  els.b.innerHTML  = hspMoney(m.bundle);
      if(els.bc) els.bc.innerHTML = hspMoney(m.bundleFull);
      if(els.sv) els.sv.innerHTML = hspMoney(m.bundleFull - m.bundle);
      if(els.s)  els.s.innerHTML  = hspMoney(m.single);
      if(els.bd) els.bd.innerHTML = perDay(m.bundle);
      if(els.sd) els.sd.innerHTML = perDay(m.single);
      if(els.sc){
        var hasCompare = m.singleFull > m.single;
        els.sc.hidden = !hasCompare;
        if(hasCompare) els.sc.innerHTML = hspMoney(m.singleFull);
      }
    }
    function applyPrice(vid){ paintPrices(); }
    /* The recommendation is always "what pair 1 is missing", read live from
       slot 1 rather than from the page's variant — which goes stale the moment
       pair 1 is changed here without a reload. It is only ever shown while the
       picker is aimed at pair 2; recommending a lens to itself is nonsense. */
    function recLens(){
      var l1 = slots[1].lens;
      if(l1 === 'focus') return 'sleep';
      if(l1 === 'sleep') return 'focus';
      if(l1 === 'relax') return 'sleep';
      return null;
    }
    function applyRec(){
      var rec = (active === 2) ? recLens() : null;
      root.dataset.rec = rec || '';
      root.querySelectorAll('.hsp__lens').forEach(function(b){
        var isRec = !!rec && b.dataset.lens === rec;
        b.classList.toggle('is-rec', isRec);
        var badge = b.querySelector('.hsp__badge');
        if(isRec && !badge){ var s=document.createElement('span'); s.className='hsp__badge'; s.textContent=(T.rec||'Rec.'); b.insertBefore(s, b.firstChild); }
        else if(!isRec && badge){ badge.parentNode.removeChild(badge); }
      });
    }
    function onVariant(vid){ applyPrice(vid); syncButton(); }

    paintSlots();
    repaintPicker();
    applyPair1();
    var last = liveVid(); if(last) onVariant(last);
    document.addEventListener('change', function(e){ if(e.target&&e.target.name==='id'){ last=e.target.value; onVariant(last); } }, true);
    /* The theme re-renders product-info on variant change, which restores the
       original button markup. This used to be a 400ms forever-poll — a main
       thread wakeup four hundred times a minute for an event that happens
       maybe twice a visit. A MutationObserver fires only when the form's DOM
       actually changes. The `syncing` flag stops our own label write from
       re-triggering the callback into a loop. */
    var syncing = false;
    function resync(){
      if(syncing) return;
      syncing = true;
      try {
        var vv = liveVid();
        if(vv && vv!==last){ last=vv; onVariant(vv); }
        else {
          /* Anything but our own last write means the theme has put its markup
             back: re-capture its label and repaint. Both modes — with add-ons,
             the one-pair label is ours too now. */
          var b = atc();
          if(b && !ours(b)){ delete b.dataset.hspOrig; delete b.dataset.hspWant; syncButton(); }
        }
      } finally { syncing = false; }
    }
    var formEl = form();
    if(formEl && 'MutationObserver' in window){
      new MutationObserver(resync).observe(formEl, { childList:true, subtree:true, characterData:true });
    } else {
      setInterval(resync, 1000);
    }
  })();
